import ConfidenceScoreSettings from 'components/admin/confidence-score-settings';
import HeatingOperatingCostCalibrationSettings from 'components/admin/heating-operating-cost-calibration-settings';
import RegionalHeatingFactorsSettings from 'components/admin/regional-heating-factors-settings';
import SizingBandsEnforcementSettings from 'components/admin/sizing-bands-enforcement-settings';
import SizingBandsSettings from 'components/admin/sizing-bands-settings';

// Admin screen hosting the ducted-system-filtering settings blocks
// (AHA-6796): per-equipment-type Sizing Bands, their Enforcement gate,
// Regional Heating Factors, and the Confidence Score configuration. Each
// block is self-contained (own state, validation, and Save), so future
// settings blocks can slot in alongside them.
export default function DuctedSystemFilteringPage() {
  return (
    <div className='mx-auto flex max-w-[1600px] flex-col gap-5'>
      <div className='text-3xl font-bold text-gray-900'>
        Ducted System Filtering
      </div>
      <SizingBandsSettings />
      <SizingBandsEnforcementSettings />
      <RegionalHeatingFactorsSettings />
      <HeatingOperatingCostCalibrationSettings />
      <ConfidenceScoreSettings />
    </div>
  );
}
